import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import React from 'react'
import { cloudfrontPath } from '@utils/image'
import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { SquareNav } from '@components/ui/nav/SquareNav'
import { HeadingWithIcon } from '@components/ui/heading/HeadingWithIcon'
import { HoverToggleImage } from '@components/ui/image/HoverToggleImage'
import { DocumentDownloadAnchor } from '@components/ui/anchor'

export const Prices = (): JSX.Element => (
  <main className="overflow-hidden mt-[22vw] lg:mt-[10.6vw] w-full min-w-full leading-[2]">
    <div className="py-[10px] pl-[20px] lg:pl-[5%] bg-[#f7f7f7] lg:bg-white">
      <BuzzkuriBreadcrumb />
    </div>
    <div className="mb-[200px]">
      <div className="lg:pb-[80px] mx-auto lg:mb-[40px] w-full text-center">
        <div className="mt-[40px] text-[20px] lg:text-[40px] font-bold leading-none text-center text-[#f0b430]">
          Prices Plan
        </div>
        <h1 className="mt-[20px] lg:mt-[20px] text-[24px] lg:text-[40px] font-bold leading-none text-center">
          料金プラン
        </h1>
      </div>

      <div id="prices-normal"></div>
      <div className="relative py-[40px] lg:py-[80px] mx-auto mt-[40px] lg:mt-[90px] w-full lg:w-[86%] lg:border-[20px] border-t-[10px] border-[#f0b430]">
        <div className="hidden lg:block absolute top-0 right-0 z-10 mt-[-25px] mr-[-20px] w-[50%] h-[200px] bg-white"></div>
        <div className="hidden lg:block absolute bottom-0 left-0 z-10 mb-[-170px] ml-[-46px] lg:w-[50%] lg:h-[180px] bg-white rotate-[10deg]"></div>
        <div className="relative lg:absolute top-0 right-0 z-20 mx-auto lg:mt-[-75px] w-[90%] lg:w-[50%]">
          <ImageWraper
            src={`${cloudfrontPath}/images/prices/prices-logo-normal@2x.png`}
            width={550}
            height={124}
          />
        </div>
        <h2 className="relative z-10 mx-auto w-[90%] lg:w-[86%] text-[24px] lg:text-[30px] font-bold">
          定期会員権 料金プラン
        </h2>
        <div className="block lg:hidden mx-[20px] mt-[8vw]">
          <div className="flex">
            <SquareNav jumpToId="light-plan">ライト</SquareNav>
            <SquareNav jumpToId="standard-plan">スタンダード</SquareNav>
            <SquareNav jumpToId="premium-plan">プレミアム</SquareNav>
          </div>
          <div className="flex">
            <SquareNav jumpToId="support-plan">
              <>
                コンサルティング
                <br />
                サポートプラン
              </>
            </SquareNav>
            <SquareNav jumpToId="operation-plan">
              運営プレミアムプラン
            </SquareNav>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row p-0 lg:px-[3.4vw] mt-[5.8vw]">
          <div className="hidden lg:flex lg:flex-col lg:justify-end lg:w-[13.88vw] lg:text-[1.1vw] font-bold">
            <div className="flex items-end pb-[10px] w-full border-b-[3px] border-[#d8d8d8] border-dotted">
              付随サービス
            </div>
            <div className="flex items-center w-full h-[5vw] border-b-[3px] border-[#d8d8d8] border-dotted">
              推奨人数
            </div>
            <div className="flex items-center w-full h-[5vw] border-b-[3px] border-[#d8d8d8] border-dotted">
              開催数
            </div>
            <div className="flex relative items-center w-full h-[6.8vw]">
              サービス利用料金(税抜)
            </div>
          </div>
          <div
            className="mx-auto lg:mr-[2.2vw] lg:ml-0 w-[80%] lg:w-[18.4vw]"
            id="light-plan"
          >
            <div className="py-[24px] px-[10px] w-full h-full bg-gradient-to-b from-[#f6a800] to-[#f57916] rounded-3xl">
              <h3 className="flex justify-center items-center text-[32px] lg:text-[2.5vw] font-bold leading-none text-white">
                ライト
              </h3>
              <div className="flex flex-col justify-center items-center py-[4.2vw] lg:py-0 px-[1.6vw] lg:px-0 mx-auto mt-[20px] lg:mt-[1.1vw] w-full h-auto lg:h-[27vw] bg-white rounded-xl">
                <span className="block lg:hidden w-full h-auto text-[4.2vw] lg:text-[18px] font-bold text-center text-[#727272]">
                  付随サービス
                </span>
                <ul className="flex flex-col justify-center w-full lg:h-[13.7vw] text-[4.8vw] lg:text-[1.25vw] font-bold border-b-[3px] border-[#d8d8d8] border-dotted">
                  <li>・システム利用</li>
                  <li>・プログラム開催/運営</li>
                  <li>・振り返り</li>
                  <li>
                    ・運営プレミアムプラン
                    <span className="text-[3.2vw] lg:text-[.8vw]">※1</span>
                  </li>
                </ul>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    推奨人数
                  </span>
                  4〜50名/回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    開催数
                  </span>
                  5回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    サービス利用料金(税抜)
                  </span>
                  1,500,000円
                </div>
              </div>
            </div>
          </div>
          <div
            className="mx-auto lg:mx-0 mt-[6.4vw] lg:mt-0 lg:mr-[2.2vw] w-[80%] lg:w-[18.4vw]"
            id="standard-plan"
          >
            <div className="py-[24px] px-[10px] lg:mr-[2.2vw] w-full h-full bg-[#de8846] rounded-3xl">
              <h3 className="flex justify-center items-center text-[32px] lg:text-[2.5vw] font-bold leading-none text-white ">
                スタンダード
              </h3>
              <div className="flex flex-col justify-center items-center py-[4.2vw] lg:py-0 px-[1.6vw] lg:px-0 mx-auto mt-[20px] lg:mt-[1.1vw] w-full h-auto lg:h-[27vw] bg-white rounded-xl">
                <span className="block lg:hidden w-full text-[4.2vw] lg:text-[4.2vw] font-bold text-center text-[#727272]">
                  付随サービス
                </span>
                <ul className="flex flex-col justify-center w-full lg:h-[13.7vw] text-[4.8vw] lg:text-[1.25vw] font-bold border-b-[3px] border-[#d8d8d8] border-dotted">
                  <li>・システム利用</li>
                  <li>・プログラム開催/運営</li>
                  <li>・振り返り</li>
                  <li>
                    ・運営プレミアムプラン
                    <span className="text-[3.2vw] lg:text-[.8vw]">※1</span>
                  </li>
                </ul>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    推奨人数
                  </span>
                  4〜50名/回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    開催数
                  </span>
                  10回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    サービス利用料金(税抜)
                  </span>
                  2,850,000円
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex flex-col mx-auto lg:mx-0 w-[80%] lg:w-[18.4vw]"
            id="premium-plan"
          >
            <div className="py-[24px] px-[10px] mt-[6.4vw] lg:mt-0 w-full h-full bg-[#d65d43] rounded-3xl">
              <h3 className="flex justify-center items-center text-[32px] lg:text-[2.5vw] font-bold leading-none text-white">
                プレミアム
              </h3>
              <div className="flex flex-col justify-center items-center py-[4.2vw] lg:py-0 px-[1.6vw] lg:px-0 mx-auto mt-[20px] lg:mt-[1.1vw] w-full h-auto lg:h-[27vw] bg-white rounded-xl">
                <span className="block lg:hidden w-full text-[4.2vw] lg:text-[4.2vw] font-bold text-center text-[#727272]">
                  付随サービス
                </span>
                <ul className="flex flex-col justify-center w-full lg:h-[13.7vw] text-[4.8vw] lg:text-[1.25vw] font-bold border-b-[3px] border-[#d8d8d8] border-dotted">
                  <li>・システム利用</li>
                  <li>・プログラム開催/運営</li>
                  <li>・振り返り</li>
                  <li>
                    ・運営プレミアムプラン
                    <span className="text-[3.2vw] lg:text-[.8vw]">※1</span>
                  </li>
                </ul>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    推奨人数
                  </span>
                  4〜50名/回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider border-b-[3px] border-[#d8d8d8] border-dotted">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    開催数
                  </span>
                  20回
                </div>
                <div className="flex relative flex-col justify-center items-center w-full h-auto lg:h-[5.9vw] text-[28px] lg:text-[1.9vw] font-bold tracking-wider">
                  <span className="block lg:hidden w-full text-[4.2vw] lg:text-[1.25vw] font-bold text-center text-[#727272]">
                    サービス利用料金(税抜)
                  </span>
                  5,000,000円
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative p-0 lg:px-[3.4vw] mx-auto mt-[12.8vw] lg:mt-[4.2vw] w-[80%] lg:w-full">
          <ul className="hidden lg:flex lg:justify-end lg:pr-[1.5vw] lg:pl-[3.88px] lg:ml-auto lg:font-bold tracking-widest lg:text-center">
            <li className="w-[27.5vw] lg:text-[1.25vw]">付随サービス</li>
            <li className="w-[20vw] lg:text-[1.25vw]">
              サービス利用料金(税抜)
            </li>
          </ul>
          <div
            className="flex after:hidden lg:after:block after:absolute after:top-0 after:right-[4vw] flex-col lg:flex-row items-center lg:p-0 px-[11px] pt-[24px] pb-[15px] after:w-[21vw] after:h-full bg-[#efc411] rounded-lg after:border-l-[3px] after:border-[#d8d8d8] after:border-dotted"
            id="support-plan"
          >
            <div className="lg:py-0 w-full lg:w-[26.8vw] text-[6.4vw] lg:text-[1.9vw] font-bold tracking-widest leading-normal lg:leading-none text-center text-white">
              コンサルティング
              <br />
              サポートプラン
            </div>
            <div className="flex flex-col lg:flex-row flex-1 lg:justify-between items-center p-[16px] lg:py-[1.1vw] lg:pr-[1.5vw] lg:pl-[3.88vw] my-[0.8vw] mt-[20px] mr-[0.8vw] w-full text-[16px] lg:text-[1.2vw] bg-white rounded-xl">
              <span className="block lg:hidden text-[4.2vw] font-bold text-center text-[#727272]">
                付随サービス
              </span>
              <ul className="pb-[20px] lg:pb-0 mt-[20px] lg:mt-0 w-full lg:w-auto text-[3.7vw] lg:text-[1.2vw] font-bold tracking-widest leading-relaxed lg:border-0 border-b-[3px] border-dotted">
                <li>・目標設定支援 </li>
                <li>・計画策定支援 </li>
                <li>・現場社員の巻き込み方支援</li>
                <li>・プログラム調整</li>
                <li>・クリエイティブ調整</li>
                <li>・レポーティング</li>
              </ul>
              <div className="lg:pl-[2.6vw] mt-[4vw] lg:mt-0 text-[6.4vw] lg:text-[1.9vw] font-bold tracking-widest text-center">
                <span className="block lg:hidden text-[4.2vw] text-[#727272]">
                  サービス利用料金(税抜)
                </span>
                200,000 円〜/月
              </div>
            </div>
          </div>
          <div
            className="flex flex-col lg:flex-row items-center lg:p-0 px-[11px] pt-[24px] pb-[15px] mt-[6.4vw] lg:mt-[0.9vw] bg-[#efc411] rounded-lg"
            id="operation-plan"
          >
            <div className="lg:py-0 w-full lg:w-[26.8vw] text-[6.4vw] lg:text-[1.9vw] font-bold tracking-widest leading-normal lg:leading-none text-center text-white">
              運営プレミアム
              <br className="lg:hidden" />
              プラン
              <span className="text-[3.2vw] lg:text-[.8vw]">※1</span>
            </div>
            <div className="flex flex-col lg:flex-row flex-1 lg:justify-between items-center p-[16px] lg:py-[1.1vw] lg:pr-[1.5vw] lg:pl-[3.88vw] my-[0.8vw] mt-[20px] mr-[0.8vw] w-full text-[16px] lg:text-[1.2vw] bg-white rounded-xl">
              <span className="block lg:hidden text-[4.2vw] font-bold text-center text-[#727272]">
                付随サービス
              </span>
              <ul className="pb-[20px] lg:pb-0 mt-[20px] lg:mt-0 w-full lg:w-auto text-[3.7vw] lg:text-[1.2vw] font-bold tracking-widest leading-relaxed lg:border-0 border-b-[3px] border-dotted">
                <li>・グループ分け指定</li>
                <li>・スクリーンショット撮影 </li>
                <li>
                  ・講師への進行依頼/注意事項
                  <br />
                  <span className="text-[2.9vw] lg:text-[0.8vw]">
                    (当てて欲しい/欲しくないの指定など){' '}
                  </span>
                </li>
                <li>
                  ・アテンドへの進行依頼/注意事項
                  <br />
                  <span className="text-[2.9vw] lg:text-[0.8vw]">
                    （遅刻者フォローなど）
                  </span>
                </li>
                <li>
                  ・クイズの順位発表
                  <span className="text-[2.9vw] lg:text-[0.8vw]">
                    （10位まで）
                  </span>
                </li>
                <li>・クライアント様のzoom利用</li>
              </ul>
              <div className="lg:pl-[2.6vw] mt-[4vw] lg:mt-0 text-[6.4vw] lg:text-[1.9vw] font-bold tracking-widest text-center">
                <span className="block lg:hidden text-[4.2vw] text-[#727272]">
                  サービス利用料金(税抜)
                </span>
                50,000 円/回
              </div>
            </div>
          </div>
        </div>

        <div className="mx-auto mt-[10.6vw] lg:mt-[1.5vw] w-[90%] lg:w-[86%] text-[3.4vw] lg:text-[1vw] text-[#707070]">
          ※1：利用期間はお申込日から90日以内の任意の日付から1年間となります。
          <br />
          ※2：契約期間はお申込日～利用期間終了日まで（自動更新）となります。
          <br />
          ※3：1回当たり4〜50名までの参加推奨・所要時間：60～90分
          <br />
          ※4：料金は契約期間分一括でのお支払いになります。
          <br />
          ※5：ワークショップ回数を超えてのご利用の際には別途追加発注が必要です
          <br />
          ※6：本サービスの実施時のオンラインMTGツール、zoomのご利用が必要となります。そのほかオンラインMTGツールについてはご利用前に担当者へご相談ください。
          <br />
          ※7：コンサルティングサポートは月8時間稼働をベースとして超過工数は1時間2.5万円（税抜）で請求いたします。
        </div>
      </div>

      <div id="prices-emo"></div>
      <div className="relative py-[8vw] lg:py-[6.25vw] mx-auto mt-[14vw] lg:mt-[15.6vw] w-full lg:w-[86%] lg:border-[20px] border-t-[10px] border-b-[10px] border-[#fadeda]">
        <div className="hidden lg:block absolute top-0 right-0 z-10 lg:mt-[-9.3vw] lg:mr-[-1.5vw] lg:w-1/2 lg:h-[18.75vw] bg-white rotate-[50deg] lg:rotate-[15deg]"></div>
        <div className="absolute bottom-0 left-0 z-10 mb-[-32vw] lg:mb-[-14vw] ml-[-8vw] lg:ml-[-3.5vw] w-[30%] lg:w-[60%] h-[32vw] lg:h-[15vw] bg-white rotate-[15deg] lg:rotate-[10deg]"></div>
        <div className="lg:absolute lg:top-0 lg:right-0 z-20 mx-auto lg:mt-[-5.8vw] w-[90%] lg:w-1/2">
          <ImageWraper
            src={`${cloudfrontPath}/images/prices/prices-logo-emo@2x.png`}
            width={550}
            height={124}
          />
        </div>
        <h2 className="relative z-10 mx-auto w-[90%] lg:w-[86%] text-[6.4vw] lg:text-[2.3vw] font-bold">
          バヅクリ エモ
        </h2>
        <p className="relative z-10 mx-auto mt-[1.3vw] lg:mt-[0.7vw] mb-[2.6vw] lg:mb-0 w-[90%] lg:w-[86%] text-[4.8vw] lg:text-[1.8vw] font-bold">
          チームビルディングのための定期イベントに使える
        </p>
        <div className="hidden lg:block mx-auto mt-[1.5vw] lg:w-[86%]">
          <ImageWraper
            src={`${cloudfrontPath}/images/prices/prices-emo-v2.svg`}
            width={1040}
            height={334}
          />
        </div>
        <div className="lg:hidden mx-auto mt-[2.6vw] w-[96%]">
          <ImageWraper
            src={`${cloudfrontPath}/images/prices/prices-sp-emo-v2.svg`}
            width={710}
            height={1442}
          />
        </div>
        <div className="mx-auto mt-[10.6vw] lg:mt-[1.5vw] w-[90%] lg:w-[86%] text-[3.4vw] lg:text-[1vw] text-[#707070]">
          ※1：契約期間・有効期間：各プラン別に定められた期間ごとに自動更新
          <br />
          ※2：1イベント当たり50名までの参加推奨
          <br />
          ※3：料金は契約期間分一括でのお支払いになります。
          <br />
          ※4：入会事務手数料別途：20万円
        </div>
        <div className="relative z-10 pt-[5.3vw] lg:pt-[2vw] pb-[10vw] lg:pb-[3.1vw] mx-auto mt-[5.3vw] lg:mt-[3.1vw] w-[90%] lg:w-[86%] border-[2px] border-[#f0b430]">
          <div className="relative mx-auto text-[5.3vw] lg:text-[1.8vw] font-bold text-center">
            <HeadingWithIcon
              iconPath="/images/prices/prices-finger.svg"
              heading="こんな企業におすすめ"
              Htag="h3"
            />
          </div>
          <p className="relative z-10 mx-auto mt-[1.3vw] lg:mt-[0.7vw] mb-[2.6vw] lg:mb-0 w-[90%] lg:w-[86%] text-[4.8vw] lg:text-[1.25vw] font-bold">
            ・～100名規模の組織コミュニケーションの活性化を図りたい
            <br />
            ・参加者メンバー固定で定期的に開催したい
            <br />
            ・30分程度のすきま時間にコミュニケーションを活性化したい
          </p>
        </div>
        <div className="relative z-10 mx-auto mt-[-30px] w-[70%] lg:w-[50%]">
          <DocumentDownloadAnchor reqRef="料金ページ・バヅクリエモ">
            <div className="relative p-[0.9vw] w-full lg:text-[1.5vw] font-bold text-center text-white bg-[#e6553a] bg-gradient-to-r hover:from-[#eb553a] hover:to-[#f0b426] rounded-full transition-all duration-300 ease cursor-pointer">
              <div>資料ダウンロード</div>
              <div className="absolute top-1/2 right-[1.1vw] w-[24px] md:w-0 lg:w-[1.8vw] translate-y-[-50%]">
                <ImageWraper
                  src={`${cloudfrontPath}/images/prices/prices-download.svg`}
                  width={24}
                  height={24}
                />
              </div>
            </div>
          </DocumentDownloadAnchor>
        </div>
        <a
          className="block relative z-20 lg:pb-[15%] mx-auto mt-[5.3vw] lg:mt-[3.1vw] w-[90%] lg:w-[86%] bg-cover lg:bg-contain cursor-pointer"
          target="_blank"
          rel="noopener noreferrer"
          href="https://hr.buzzkuri.com/emo"
        >
          <div className="md:w-auto">
            <HoverToggleImage
              imageWidth={2080}
              imageHeight={400}
              hoverImagePath="/images/prices/prices-emobanner-hover.jpg"
              defaultImagePath="/images/prices/prices-emobanner.jpg"
            />
          </div>
          <div className="w-auto md:w-0">
            <ImageWraper
              src={`${cloudfrontPath}/images/prices/prices-sp-emobanner.jpg`}
              width={660}
              height={720}
            />
          </div>
        </a>
      </div>
    </div>
  </main>
)
